/**
 * Fragment de routes du paquet v7-p03-planification (vague V7 ; un fragment par paquet, `routes/v7.tsx` interdit, règle
 * R2 du découpage V4–V11). Composants chargés à la demande (règle de chargement du registre : aucun code d'écran dans le
 * paquet principal, aucun effet au chargement).
 * Routes du socle remplacées : `/programme` → programme-vue, `/programme/backlog` → programme-backlog (l'écran du socle
 * `screens/niveaux/programme/BacklogProgramme` appartient à la zone du paquet), `/programme/dependances` →
 * programme-dependances (le hub générique des dépendances reste servi par ses autres routes). Neuves : la fiche d'un
 * élément de tête et le dialogue de déclaration (écran routé : l'écran d'arrivée vérifie lui-même l'accès).
 */
import { lazy, Suspense, type ComponentType, type JSX } from 'react'

import type { Session } from '../../auth/session'
import type { ContexteRoutes, FragmentRoutes } from './registre'

const ProgrammeVue = lazy(() => import('../ecrans/v7/planification/ProgrammeVue'))
const ProgrammeBacklog = lazy(() => import('../ecrans/v7/planification/ProgrammeBacklog'))
const ProgrammeElementFiche = lazy(() => import('../ecrans/v7/planification/ProgrammeElementFiche'))
const ProgrammeDependances = lazy(() => import('../ecrans/v7/planification/ProgrammeDependances'))
const DialogueDeclarerDependance = lazy(() => import('../ecrans/v7/planification/DialogueDeclarerDependance'))

function ecran(Composant: ComponentType<{ session: Session }>) {
  return ({ session, t }: ContexteRoutes): JSX.Element => (
    <Suspense fallback={<p role="status">{t('v10.primitives.assemblage.chargement')}</p>}>
      <Composant session={session} />
    </Suspense>
  )
}

export const fragment: FragmentRoutes = {
  zone: 'v7-planification',
  routes: [
    { chemin: '/programme', element: ecran(ProgrammeVue), remplace: true },
    { chemin: '/programme/backlog', element: ecran(ProgrammeBacklog), remplace: true },
    { chemin: '/programme/backlog/element', element: ecran(ProgrammeElementFiche) },
    { chemin: '/programme/dependances', element: ecran(ProgrammeDependances), remplace: true },
    { chemin: '/programme/dependances/nouvelle', element: ecran(DialogueDeclarerDependance) },
  ],
}
